import { GET_SSO_TOKEN, GET_SSO_TOKEN_SUCCESS, GET_SSO_TOKEN_ERROR, GET_SSO_TOKEN_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetSsoToken = (state = initialState, action) => {
  switch (action.type) {
    case GET_SSO_TOKEN:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_SSO_TOKEN_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_SSO_TOKEN_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_SSO_TOKEN_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetSsoToken;
